const stripNonAlphaNumeric = (str: string): string => {
  str = str.normalize("NFD").replace(/\p{Diacritic}/gu, "");
  return str.replace(/[^a-z0-9\s]/gi, "");
};

const isEmailAddressValid = (email: string): boolean => /\S+@\S+\.\S+/.test(email);

const isPhoneNumberValid = (phoneNumber: string): boolean =>
  /(^\+[0-9]{2}|^\+[0-9]{2}\(0\)|^\(\+[0-9]{2}\)\(0\)|^00[0-9]{2}|^0)([0-9]{9}$|[0-9\-\s]{10}$)/.test(
    phoneNumber
  );

const stringContainsOnlyDigits = (str: string): boolean => /^\d+$/.test(str);

export { stripNonAlphaNumeric, isEmailAddressValid, isPhoneNumberValid, stringContainsOnlyDigits };
